import { render } from "./CustomValidationRules.vue?vue&type=template&id=7a9ba9b8"
import script from "./CustomValidationRules.vue?vue&type=script&lang=js"
export * from "./CustomValidationRules.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__